import { useState, type FormEvent } from 'react';
import { Button } from '../../design-system/components/Button';
import { Spinner } from '../../design-system/components/Spinner';
import { TextField } from '../../design-system/components/TextField';
import { ErrorState } from '../../shared/components/ErrorState';
import { SearchResults } from './components/SearchResults';
import { useSearchTranscripts } from './hooks';

export function SearchScreen() {
  const [input, setInput] = useState('');
  const [submitted, setSubmitted] = useState('');
  const query = useSearchTranscripts({ q: submitted }, submitted.trim().length >= 2);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setSubmitted(input.trim());
  };

  return (
    <div className="dash-section">
      <div className="dash-section__header">
        <h1 className="dash-section__title">Buscar em transcripts</h1>
      </div>
      <form className="dash-search__form" onSubmit={handleSubmit}>
        <TextField
          label="Termo"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Ex.: proposta, objeção, preço"
          helperText="Mínimo 2 caracteres. A busca ignora acentos."
          autoFocus
        />
        <Button type="submit" disabled={input.trim().length < 2}>
          Buscar
        </Button>
      </form>

      {submitted.trim().length < 2 ? null : query.isPending ? (
        <div className="center">
          <Spinner label="Buscando" />
        </div>
      ) : query.isError ? (
        <ErrorState error={query.error} onRetry={() => query.refetch()} />
      ) : (
        <SearchResults envelope={query.data} />
      )}
    </div>
  );
}
